// 门店管理
export default [
  {
    path: "/storeManage",
    name: "storeManage",
    meta: { title: "门店管理" },
    component: () => import("../views/storeManage/index.vue"),
    children: [
      {
        path: "/storeManage/storeList",
        name: "storeList",
        meta: { title: "门店列表", isMenu: true },
        component: () => import("../views/storeManage/storeList.vue"),
      },
    ],
  },
]
